<template>
  <v-row v-if="ready" class="pt-5">
    <v-col cols="10" offset="1">
      <v-row>
        <v-col cols="12">
           <h2 class="headline">Like</h2>
           <tiles-words :tiles="filteredLike" />
           <h2 class="headline">Dislike</h2>
           <tiles-words :tiles="filteredDislike" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import lodash from "lodash";
import { mapState } from "vuex";
import { store } from "@/store.js";
// import { BarDonought, BarGraph } from "@/components/graphs";
import {
  TilesWords,
} from "@/components/results/keywords/modules";

export default {
  name: "ResultsKeywordsSummary",
  data() {
    return {
      doc: null,
      intervalId: null,
      ready: false,
      maxLike: 0,
      maxDisLike: 0
    };
  },
  components: {
    // BarDonought,
    // BarGraph,
    TilesWords
  },
  props: {
    id: String,
    summaryMode: {
      type: String,
      default: "combined",
    }
  },
  mounted() {
    this.getList();
    this.init();
  },
  computed: {
    ...mapState(["exKeywords","keywords"]),
    filteredLike() {
      let items = [];
      let distribution = this.likeList.reduce(
        (acum, cur) =>
          Object.assign(acum, { [cur.id]: (acum[cur.id] | 0) + 1 }),
        {}
      );
      for (var element in distribution) {
        items.push({ el: element, count: distribution[element] });
      }
      items.map((item) => {
        let tile = this.keywords.find((x) => x.id === item.el);
        item.title = tile.title;
        item.percentage = this.getPercentage(item.count, true);
      });
      return lodash.orderBy(items, "count", "desc");
    },
    filteredDislike() {
      let items = [];
      let distribution = this.disLikeList.reduce(
        (acum, cur) =>
          Object.assign(acum, { [cur.id]: (acum[cur.id] | 0) + 1 }),
        {}
      );
      for (var element in distribution) {
        items.push({ el: element, count: distribution[element] });
      }
      items.map((item) => {
        let tile = this.keywords.find((x) => x.id === item.el);
        item.title = tile.title;
        item.percentage = this.getPercentage(item.count, false);
      });
      return lodash.orderBy(items, "count", "desc");
    },
    likeList() {
      return this.exKeywords.filter(item => item.like == true)
    },
    disLikeList() {
      return this.exKeywords.filter(item => item.like == false)
    },
    filteredSort() {
      return lodash.orderBy(this.filteredList, "count", "desc");
    },
    unit() {
      return this.max / 100;
    },
    grouped() {
      return lodash.groupBy(this.exKeywords, "index");
    },
  },
  methods: {
    init() {
       let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
          vm.checkStatus();
        }, 300);
    },
    checkStatus() {
      if (this.exKeywords && this.keywords) {
        this.setMaxLike();
        this.setMaxDisLike();
        this.ready = true;
        clearInterval(this.intervalId);
      }
    },
    getSubGroup(group) {
      let items = [];
      let distribution = group.reduce(
        (acum, cur) =>
          Object.assign(acum, { [cur.id]: (acum[cur.id] | 0) + 1 }),
        {}
      );
      for (var element in distribution) {
        items.push({ el: element, count: distribution[element] });
      }
      items.map((item) => {
        item.title = this.getTitle(item.el);
        item.percentage = this.getPercentage(item.count);
      });
      return items;
    },
    setMaxLike() {
      this.maxLike = Math.max.apply(
        null,
        this.filteredLike.map((item) => item.count)
      );
    },
    setMaxDisLike() {
      this.maxDisLike = Math.max.apply(
        null,
        this.filteredDislike.map((item) => item.count)
      );
    },
    getList() {
      let ref = fb.keywordsCollection;
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            store.commit("setKeywords", items);
          }
        })
        .catch(function() {});
    },
    getTitle(id) {
      let tile = this.keywords.find((item) => item.id === id);
      return tile.title;
    },
    getLike(id) {
      let tile = this.keywords.find((item) => item.id === id);
      return tile.like;
    },
    getPercentage(count, like) {
      let unit;
      if (like) {
        unit = 100 / this.maxLike;
      } else {
        unit = 100 / this.maxDisLike;
      }
      return `${count * unit}%`;
    }
  },
};
</script>
